/* eslint-disable no-constructor-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
// import { message } from 'antd';
// import { useNavigate } from 'react-router-dom';
import { SOCKET_ACTIONS } from './config';
import store from '../redux/store';
import { removeItem } from '../utility/localStorageControl';

class WebSocketManager {
  
  constructor() {
    if (WebSocketManager.instance) {
      return WebSocketManager.instance;
    }
    // this.navigate = useNavigate();
    this.socket = null;
    this.socketUrl = null;
    this.token = null;
    this.readyState = WebSocket.CLOSED;
    this.eventObservers = {};
    this.retryInterval = null;

    WebSocketManager.instance = this;
    return this;
  }

  /**
   * Connect to a WebSocket server.
   * @param {string} url - WebSocket URL.
   * @param {string} token - Bearer token for authentication.
   */
  connect(url, token) {
    if (this.socket) {
      this.disconnect();
    }

    this.socketUrl = url;
    this.token = token;

    this.socket = new WebSocket(`${url}?token=${encodeURIComponent(token)}`);

    this.socket.onopen = () => {
      this.readyState = WebSocket.OPEN;
      // message.success('WebSocket connected');
      console.log('WebSocket connected');
      this.clearRetry();
    };

    this.socket.onclose = (event) => {
      try {
        const jsonStr = event.reason
        const responseObj = JSON.parse(jsonStr);
        if (Number(responseObj.event_id) === SOCKET_ACTIONS.UNAUTHORIZED) {
          removeItem('access_token')
          window.location.reload();
          // store.dispatch(logOut())
        }
      } catch (error) {
        console.log(error)
      }
      this.readyState = WebSocket.CLOSED;
      // message.error('WebSocket disconnected');
      console.log('WebSocket disconnected');
      this.startRetry();
    };

    this.socket.onerror = (error) => {
      // message.error('WebSocket error');
      console.error('WebSocket error:', error);
    };

    this.socket.onmessage = (event) => {
      try {
        const parsedData = JSON.parse(event.data);
        console.log('WebSocket Message Received:', parsedData);

        // Trigger event observers
        if (parsedData.event_id && this.eventObservers[parsedData.event_id]) {
          this.eventObservers[parsedData.event_id].forEach((callback) =>
            callback(parsedData)
          );
        }
      } catch (error) {
        console.error('Error parsing WebSocket message:', error);
      }
    };
  }

  /**
   * Disconnect from the WebSocket server.
   */
  disconnect() {
    if (this.socket) {
      this.socket.close(1000, 'Socket Closed Manually');
      this.socket = null;
      this.readyState = WebSocket.CLOSED;
      // message.info('WebSocket connection closed !');
    }
  }

  /**
   * Start retrying connection every 5 seconds if authUser is available.
   * @param {function} isAuthUserAvailable - Callback to check if authUser is available.
   */
  isAuthUserAvailable() {
    const state = store.getState();
    const { auth } = state;
    const authUser = auth?.data || null
    return authUser || false; // Adjust based on your state structure
  }


  /**
   * Start retrying connection every 5 seconds if authUser is available.
   * @param {function} isAuthUserAvailable - Callback to check if authUser is available.
   */
  startRetry() {
    if (this.retryInterval) return;

    this.retryInterval = setInterval(() => {
      if (this.isAuthUserAvailable() && this.readyState === WebSocket.CLOSED) {
        console.log('Retrying WebSocket connection...');
        this.connect(this.socketUrl, this.token);
      }
    }, 5000);
  }


  /**
   * Clear the retry interval.
   */
  clearRetry() {
    if (this.retryInterval) {
      clearInterval(this.retryInterval);
      this.retryInterval = null;
    }
  }

  /**
   * Send a message as a plain string.
   * @param {string} messageStr - Message to send.
   */
  sendMessage(messageStr) {
    if (this.socket && this.readyState === WebSocket.OPEN) {
      this.socket.send(messageStr);
      console.log('Message Sent:', messageStr);
    } else {
      console.error('Cannot send message, WebSocket is not connected.');
    }
  }

  /**
   * Send a message as a JSON object.
   * @param {object} jsonMessage - JSON message to send.
   */
  sendJsonMessage(jsonMessage) {
    if (this.socket && this.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(jsonMessage));
      console.log('JSON Message Sent:', jsonMessage);
    } else {
      console.error('Cannot send JSON message, WebSocket is not connected.');
    }
  }

  /**
   * Get the current connection status.
   * @returns {string} - Connection status.
   */
  getConnectionStatus() {
    const states = {
      [WebSocket.CONNECTING]: 'Connecting',
      [WebSocket.OPEN]: 'Open',
      [WebSocket.CLOSING]: 'Closing',
      [WebSocket.CLOSED]: 'Closed',
    };
    return states[this.readyState] || 'Unknown';
  }

  /**
   * Get the current WebSocket instance.
   * @returns {WebSocket|null} - Current WebSocket instance or null if not connected.
   */
  getConnection() {
    return this.socket;
  }

  /**
   * Register an observer for a specific event.
   * @param {string} actionId - The action ID to listen for.
   * @param {function} callback - The callback to trigger when the event occurs.
   */
  registerObserver(actionId, callback) {
    if (!this.eventObservers[actionId]) {
      this.eventObservers[actionId] = [];
    }
    this.eventObservers[actionId].push(callback);
  }

  /**
   * Unregister an observer for a specific event.
   * @param {string} actionId - The action ID to stop listening for.
   * @param {function} callback - The callback to remove from the observer list.
   */
  unregisterObserver(actionId, callback) {
    if (this.eventObservers[actionId]) {
      this.eventObservers[actionId] = this.eventObservers[actionId].filter(
        (cb) => cb !== callback
      );
      if (this.eventObservers[actionId].length === 0) {
        delete this.eventObservers[actionId];
      }
    }
  }
}

export default new WebSocketManager();
